/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";
import { Link } from "react-router-dom";

import { Accordion } from "react-accessible-accordion";
import CustomAccordionItem from "./helpCenterAccordionItem";

const DomainBody = () => (
  <div>
    <Link to="/help/domains">Select Domain</Link>
  </div>
);
const ContentBody = () => (
  <div>
    <div className="mb-2">
      <Link to="/help/contents/addNewAssets">Add New Assets</Link>
    </div>
    <div>
      <Link to="/help/contents/manageContents">Manage Contents</Link>
    </div>
  </div>
);
const PlaylistBody = () => (
  <div>
    <Link to="/help/playlists">Creating Playlists</Link>
  </div>
);

const CampaignBody = () => (
  <div>
    <div className="mb-2">
      <Link to="/help/campaigns/campaignsAndContent">
        Campaigns and Content
      </Link>
    </div>
    <div>
      <Link to="/help/campaigns/manageCampaign">Manage Campaign</Link>
    </div>
  </div>
);

const CalendarBody = () => (
  <div>
    <Link to="/help/calendars">Scheduling Content</Link>
  </div>
);

const NetworkBody = () => (
  <div>
    <Link to="/help/networks">Deploying Content to Players </Link>
  </div>
);

const FAQBody = () => (
  <div>
    <Link to="/help/FAQ">Frequently Asked Questions </Link>
  </div>
);
const CommonRequestBody = () => (
  <div>
    <Link to="/help/Common Request">Common Requests </Link>
  </div>
);

export default function HelpCenter() {
  return (
    <div className="mainPage">
      <div className="contentSection">
        <div className="helpCenter">
          <Accordion className="customAccordion" allowZeroExpanded>
            <CustomAccordionItem title="Domains" body={<DomainBody />} />
            <CustomAccordionItem title="Contents" body={<ContentBody />} />
            <CustomAccordionItem title="Playlists" body={<PlaylistBody />} />
            <CustomAccordionItem title="Campaigns" body={<CampaignBody />} />
            <CustomAccordionItem title="Calendars" body={<CalendarBody />} />
            <CustomAccordionItem title="Networks" body={<NetworkBody />} />
            <CustomAccordionItem title="FAQ" body={<FAQBody />} />
            <CustomAccordionItem
              title=" Common Requests"
              body={<CommonRequestBody />}
            />
          </Accordion>
        </div>
      </div>
    </div>
  );
}
